import { redactTelemetryValue } from "@kudoz/shared/redactDiagnostics";

const isDev: boolean =
  (import.meta as ImportMeta & { env?: { DEV?: boolean } }).env?.DEV ??
  process.env.NODE_ENV !== "production";

const noop = (): void => {};

function scrubArgs(args: unknown[]): unknown[] {
  return args.map((arg) => redactTelemetryValue(arg));
}

/**
 * Client-side logger.
 * Debug/info logs are suppressed in production builds so they
 * never appear in end-user devtools. Warnings and errors always surface.
 */
export const logger = {
  log: isDev
    ? (...args: unknown[]): void => {
        console.log(...scrubArgs(args));
      }
    : noop,
  info: isDev
    ? (...args: unknown[]): void => {
        console.info(...scrubArgs(args));
      }
    : noop,
  warn: (...args: unknown[]): void => {
    console.warn(...scrubArgs(args));
  },
  error: (...args: unknown[]): void => {
    console.error(...scrubArgs(args));
  },
};
